import { createQuery } from "react-query-kit";
import { generatePath } from "react-router-dom";

import type { IAppointmentDetailEndpoint } from "./types";

import type { AxiosError, IApiResponse, IAxiosFn } from "@api/types";
import { axiosClient } from "@/api/clients";

const key = "appointmentDetail";

type IResponse = IApiResponse<IAppointmentDetailEndpoint>;
interface IVariables {
  id: string;
}

export const getAppointmentDetail: IAxiosFn<IVariables, IResponse> = async (
  params,
  signal,
) => {
  const { data } = await axiosClient.get(
    generatePath("/appointments/:appointment_id", {
      appointment_id: params.id.toString(),
    }),
    {
      signal,
    },
  );

  return data;
};

export const useAppointmentDetail = createQuery<
  IResponse,
  IVariables,
  AxiosError
>({
  primaryKey: key,
  queryFn: ({ queryKey: [_primaryKey, variables], signal }) =>
    getAppointmentDetail(variables, signal),
});
